import { berachain } from "viem/chains";

export const PRIMARY_CHAIN_ID = berachain.id;
export const PRIMARY_BLOCK_EXPLORER_URL = berachain.blockExplorers.default.url;
